import { Group, Stack, createStyles } from '@mantine/core';
import { format, isDate } from 'date-fns';

import dt from '~/domains/contest/domains/manage/domains/common/testing.const';
import { Text } from '~/domains/design-system/Text';

import { pluralizeSlateLabel } from '../../../utils/pluralizeSlateLabel';

import type { SegmentsSegmentType } from './types';

const useViewStyles = createStyles((theme) => ({
  segment: {
    borderBottom: `1px solid ${theme.colors.gray[3]}`,
    padding: `${theme.spacing.xs}px 0`,
  },
}));

export function SegmentsView({
  segments,
  slateLabel = 'Tournaments',
}: {
  segments: SegmentsSegmentType[];
  slateLabel?: string;
}) {
  const { classes } = useViewStyles();

  return (
    <>
      {segments.map((segment) => (
        <Group
          key={segment.key}
          position="apart"
          className={classes.segment}
          data-test-id={dt.segments.view.segment}
        >
          <Text variant="subhead-medium">{segment.label}</Text>
          <Stack /* eslint-disable-line local-rules/use-theme-tokens */ spacing={2} ta="right">
            <Text variant="body-large">
              {segment.items.length} {pluralizeSlateLabel(segment.items.length, slateLabel)}
            </Text>
            <Text variant="body-large">
              {isDate(segment.items[0]?.date) ? (
                <>{format(segment.items[0]?.date, 'M/dd')} - </>
              ) : null}
              {isDate(segment.items[segment.items.length - 1]?.date) ? (
                <>{format(segment.items[segment.items.length - 1]?.date, 'M/dd')} </>
              ) : null}
            </Text>
          </Stack>
        </Group>
      ))}
    </>
  );
}
